import React from "react";
import styled from "styled-components";
import { z } from "zod";
import { Blade } from "../../../components/Blade";
import { MastheadBackdrop } from "./Backdrop";
import { HeaderBar } from "./HeaderBar";
import { MastheadCarousel } from "./MastheadCarousel";
import { Availability } from "./Availability";
import { MastheadContentBox } from "../styles";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../skins/types";
import { riotProductSkin } from "../skins/riot-product";
import { leagueClientSkin } from "../skins/league-client";
import { ProductMastheadBladeSchema } from "../../../schemas/blades/ProductMasthead";
export const GameDetailMastheadContractSchema = ProductMastheadBladeSchema.extend({
    type: z.literal("gameDetailMasthead"),
});
const _GameDetailMasthead = (props) => {
    const { backdrop, links, logo, tagline, contentList, availability, ...GDProps } = props;
    const availabilityCheck = !!availability?.links?.length;
    return (React.createElement(Blade, { "data-testid": "GameDetailMasthead", ...GDProps },
        React.createElement(MastheadBackdrop, { "data-testid": "GameDetailMasthead-Backdrop", ...backdrop }),
        React.createElement("div", { className: "layout" },
            React.createElement(HeaderBar, { "data-testid": "GameDetailMasthead-HeaderBar", links: links, logo: logo, tagline: tagline }),
            React.createElement(MastheadContentBox, null),
            availabilityCheck ? React.createElement(Availability, { "data-testid": "GameDetailMasthead-Availability", ...availability }) : null,
            contentList ? React.createElement(MastheadCarousel, { "data-testid": "GameDetailMasthead-Carousel", contentList: contentList }) : null)));
};
export const GameDetailMasthead = styled(_GameDetailMasthead) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
    [SkinId.LeagueClient]: leagueClientSkin,
})}
`;
//# sourceMappingURL=GameDetailMasthead.js.map